import { LocalStorageKey, NgLocalStorageKey } from 'shared-types/SharedEnums';

export const NgStorage = 'ngStorage-';
export const NBIDiaryLocalStoragePrefix = 'nbi_diary_';
export const NBIDiaryMobileLocalStoragePrefix = 'nbi_diary_mobile_';
export const NBIAdminLocalStoragePrefix = 'nbi_admin_';

/**
 * To do: Horita
 * Should be add key which need NBIDiaryLocalStoragePrefix
 */
export const StorageDiaryKey: string[] = [
  NgLocalStorageKey.venue,
  NgLocalStorageKey.token,
  NgLocalStorageKey.isManager,
  NgLocalStorageKey.accountLocked,
  NgLocalStorageKey.isPosActive,
  LocalStorageKey.authorisationServer,
  LocalStorageKey.client,
  LocalStorageKey.redirectUri,
  LocalStorageKey.codeVerifier,
  LocalStorageKey.accessToken,
  LocalStorageKey.refreshToken,
  LocalStorageKey.idToken,
  LocalStorageKey.isLegacyLogin,
  LocalStorageKey.offlineStatus,
];

export const StorageAdminKey: string[] = [
  LocalStorageKey.token,
  LocalStorageKey.account,
  NgLocalStorageKey.selectedDiaryView,
];
